/**
 * Resolve delivery vs pickup for a cart instance.
 * Checkout primarily stores `deliveryOption` on `checkoutSnapshot` (and the
 * Transaction); it is not always copied to the cart-instance top level.
 *
 * @param {object|null|undefined} instanceData
 * @returns {'pickup'|'delivery'|string|null}
 */
export function resolveCartDeliveryOption(instanceData) {
  if (!instanceData || typeof instanceData !== 'object') {
    return null;
  }

  const topLevel = instanceData.deliveryOption;
  if (typeof topLevel === 'string' && topLevel.trim()) {
    return topLevel.trim();
  }

  const snapshotOption = instanceData.checkoutSnapshot?.deliveryOption;
  if (typeof snapshotOption === 'string' && snapshotOption.trim()) {
    return snapshotOption.trim();
  }

  const orderId = instanceData.orderid || instanceData.transactionId;
  const pending = orderId && instanceData.pendingCheckoutSnapshots?.[orderId];
  const pendingOption = pending?.deliveryOption;
  if (typeof pendingOption === 'string' && pendingOption.trim()) {
    return pendingOption.trim();
  }

  return null;
}

/**
 * Whether a packed cart should show the pickup verification QR.
 * Only when we can resolve the option as pickup (or default when unset —
 * historically unset means pickup). Explicit delivery never shows the QR.
 *
 * @param {object|null|undefined} instanceData
 * @returns {boolean}
 */
export function shouldShowPickupVerificationQr(instanceData) {
  if (!instanceData || instanceData.status !== 'packed_awaiting_pickup') {
    return false;
  }
  return resolveCartDeliveryOption(instanceData) !== 'delivery';
}
